<template>
  <div class="home">
    <div class="card mb-3">
      <div class="card-body">
        <div class="md-form">
          <label for="article-titre">Le titre de l'article</label>
          <input type="text" class="form-control my-3" v-model="titre" />
        </div>
      </div>
      <div class="card-footer">
        {{ slug }}
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div class="md-form">
          <i class="fas fa-pencil-alt prefix"></i>
          <textarea
            class="md-textarea form-control"
            v-model="resume"
            rows="3"
          ></textarea>
          <label for="form10">resume</label>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroupFileAddon01"
              >Upload</span
            >
          </div>
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              lang="fr"
              @change="previewImage"
              accept="image/*"
            />
            <label class="custom-file-label" for="article-image"
              >Sélectionner le fichier
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div class="md-form">
          <!-- <i class="fas fa-pencil-alt prefix"></i> -->
          <ckeditor
            :editor="editor"
            v-model="editorData"
            :config="editorConfig"
          ></ckeditor>

          <!-- <label for="article-content">le contenu de l'article</label> -->
        </div>
        <span
          class="toto"
          data-toggle="tooltip"
          title="L'article doit comprendre un minimum de 250 caractères"
          >0</span
        >
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="progress">
          <div
            id="prog"
            class="progress-bar"
            role="progressbar"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{ width: uploadValue + '%' }"
          ></div>
        </div>
        <br />
        <button
          type="button"
          :class="
            'btn btn-primary btn-lg btn-block ' +
              (!titre || !resume || !editorData || !imageData ? 'disabled' : '')
          "
          @click="post"
        >
          Publier <i class="fas fa-pencil-alt ml-2" aria-hidden="true"></i>
        </button>
        <div
          class="alert alert-danger text-center d-none"
          id="pubError"
          role="alert"
        >
          Une erreur est survenue lors du chargement du contenu
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { db } from "@/firebase";
import { storage } from "@/firebase";
import { auth } from "@/firebase";

export default {
  data() {
    return {
      Active: true,
      titre: null,
      imageData: null,
      uploadValue: 0,
      editorData: "",
      editor: ClassicEditor,
      resume: null,
      editorConfig: {
        language: "fr"
        // The configuration of the editor.
      },
      authUid: null,
      authorEmail: null,
      slug: null
    };
  },
  created() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.authUid = user.uid;
        this.authorEmail = user.email;
        console.log("user", user);
      } else {
        console.log("no logged");
      }
    });
  },
  methods: {
    previewImage(event) {
      this.imageData = event.target.files[0];
    },
    post() {
      const storageRef = storage
        .ref()
        .child("articles/" + this.imageData.name)
        .put(this.imageData);
      storageRef.on(
        "state_changed",
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.Active = false;
        },
        error => {
          console.log(error);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            db.ref()
              .child("articles")
              .push({
                arId: 2,
                authUid: this.authUid,
                content: this.editorData,
                image: url,
                invertedtimeStamp: "-" + Date.now(),
                pubDate: new Date().toLocaleDateString("fr"),
                resume: this.resume,
                titre: this.titre,
                slug: this.slug
              })
              .then(() => {
                console.log("done");
              });
          });
        }
      );
    }
  },
  watch: {
    titre: function() {
      this.slug = this.titre
        .trim()
        .toLowerCase()
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-"); // Replace multiple - with single -

      console.log("watched");
    }
  }
};
</script>
<style lang="scss" scoped>
.ck.ck-editor__main > .ck-editor__editable {
  height: 450px !important;
}
</style>